import { useLanguage } from "../context/LanguageContext";
import { Reveal, SectionHeading } from "./Reveal";
import { PhotoFrame } from "./PhotoFrame";
import { PHOTOS } from "../data/siteData";

const SPANS = [
  "col-span-2 row-span-2",
  "col-span-2 row-span-1 md:col-span-1 md:row-span-2",
  "col-span-1 row-span-1",
  "col-span-1 row-span-1",
  "col-span-2 row-span-1",
];

export const Gallery = () => {
  const { lang, t } = useLanguage();

  return (
    <section id="galeria" className="scroll-mt-20 py-20 sm:py-28" data-testid="gallery-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <Reveal>
          <SectionHeading eyebrow={t.gallery.eyebrow} title={t.gallery.title} testId="gallery-heading" />
        </Reveal>

        <div
          className="grid auto-rows-[170px] grid-flow-dense grid-cols-2 gap-3 sm:auto-rows-[210px] md:grid-cols-4"
          data-testid="gallery-grid"
        >
          {PHOTOS.gallery.map((photo, i) => (
            <Reveal key={photo.src + i} delay={0.06 * i} className={SPANS[i % SPANS.length]}>
              <PhotoFrame
                src={photo.src}
                alt={photo.alt[lang]}
                label={`FOTO 0${i + 1}`}
                testId={`gallery-photo-${i + 1}`}
                className="h-full w-full"
              />
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <p className="mt-4 text-xs text-zinc-500" data-testid="gallery-note">
            {t.gallery.note}
          </p>
        </Reveal>
      </div>
    </section>
  );
};
